<template>
  <div ref="w" v-loading="loading">
    <div v-html="content" class="mian_view">资讯</div>
  </div>
</template>

<script>
import infoApi from "@/api/infoH5";

export default {
  data() {
    return {
      width: 0,
      width1: 0,
      width2: "",
      content: "",
      loading: true,
    };
  },
  created() {
    try {
      this.width = window.innerWidth;
      this.width2 = document.body.clientWidth;
      this.$nextTick((res) => {
        this.width1 = this.$refs.w.innerWidth;
      });
    } catch (error) {}

    this.getinfoDatalist();
  },
  methods: {
    async getinfoDatalist() {
      //console.log(this.$route.params.id);
      let params = {
        id: this.$route.params.id,
      };
      const { data } = await infoApi.getInformationById(params);
      if (data.code === 200 && data.status === "1") {
        this.content = data.data.content;
        setTimeout(() => {
          this.loading = false;
        }, 500);
      }
      console.log(data, "资讯数据");
    },
  },
};
</script>

<style lang="scss" scoped>
.mian_view {
  width: 375px;
  // // height: 100%;
  // height: 667px;
  // overflow-y: scroll;
  word-break: break-all !important;
  word-wrap: break-word;
  text-align: justify;
  padding: 16px !important;
}
</style>